export const ADD_POPUP = 'ADD_POPUP';
export const CLOSE_POPUP = 'CLOSE_POPUP';
export const CLOSE_POPUPS = 'CLOSE_POPUPS';
export const NAV_PREV = 'NAV_PREV';
export const NAV_NEXT = 'NAV_NEXT';
export const NAV_BY_INDEX = 'NAV_BY_INDEX';
export const UPDATE_POPUP = 'UPDATE_POPUP';
export const DISABLE_POPUPS = 'DISABLE_POPUPS';
export const ENABLE_POPUPS = 'ENABLE_POPUPS';

export const addPopupAction = ({
    id,
    component,
    render = null,
    layer,
    isModal = false,
    addFirst = false,
    singletonMode = '',
    onClose,
    closeAll,
    ...other
}) => ({
    type: ADD_POPUP,
    payload: {
        id,
        component,
        render,
        layer,
        isModal,
        addFirst,
        singletonMode,
        onClose,
        closeAll,
        ...other
    }
});

export const closePopupAction = id => ({
    type: CLOSE_POPUP,
    payload: {
        id
    }
});

export const closePopupsAction = ({ popups, exclude, excludeLayers } = {}) => ({
    type: CLOSE_POPUPS,
    payload: {
        popups,
        exclude,
        excludeLayers
    }
});

export const navigatePrevAction = () => ({
    type: NAV_PREV
});

export const navigateNextAction = () => ({
    type: NAV_NEXT
});

export const navigateByIndexAction = index => ({
    type: NAV_BY_INDEX,
    payload: {
        index
    }
});

export const updatePopupAction = ({ id, ...data }) => ({
    type: UPDATE_POPUP,
    payload: {
        id,
        ...data
    }
});

export const disablePopupsAction = () => ({
    type: DISABLE_POPUPS
});

export const enablePopupsAction = () => ({
    type: ENABLE_POPUPS
});
